import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { applyTheme, readThemePreference, reloadOnStaleChunk, resolveTheme } from '@inferrex/ui';
import { App } from './App';
import './styles.css';

// A tab still on the previous build asks for chunks the new deploy no longer has; reload once.
reloadOnStaleChunk();

// Theme before the first paint, so a dark-theme reader never sees a white flash.
applyTheme(resolveTheme(readThemePreference()));

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
